import {
  REPLACE_CURRENT_USER,
  RESET_CURRENT_USER,
  SET_CURRENT_USER_DIRTY,
  ADD_CURRENT_USER_PENDING_DOCUMENTS,
  RESET_CURRENT_USER_PENDING_DOCUMENTS,
  UPDATE_CURRENT_USER,
} from './constants';

export const replaceCurrentUser = (user) => ({
  type: REPLACE_CURRENT_USER, payload: user,
});

export const updateCurrentUser = ({ user, dirty, meta }) => ({
  type: UPDATE_CURRENT_USER, payload: { user, dirty }, meta,
});

export const setCurrentUserDirty = (dirty) => ({
  type: SET_CURRENT_USER_DIRTY, payload: dirty,
});

export const addCurrentUserPendingDocuments = (payload, meta) => ({
  type: ADD_CURRENT_USER_PENDING_DOCUMENTS, payload, meta,
});

export const resetCurrentUserPendingDocuments = (payload, meta) => ({
  type: RESET_CURRENT_USER_PENDING_DOCUMENTS, payload, meta,
});

export const resetCurrentUser = () => ({
  type: RESET_CURRENT_USER,
});
